module.exports = {
  condition: '条件',
  display: '显示',
  hide: '隐藏',
  import: '导入',
  export: '导出',
  have: '有',
  none: '无',
  closure: '关闭',
  refresh: '刷新',
  confirm: '确定',
  search: '查询',
  cancel: '取消',
  prompt: '提示',
  returnIndex: '返回首页',
  returnLastPage: '返回上一页',
  select: '请选择',
  clearSearchOption: '清空查询条件',
  operate: '操作',
  operatedSuccess: '操作成功!',
  batchOperateSuccess: "批量操作成功!",
  requestedFail: '请求失败!',
  operatedFail: '操作失败,请重试!',
  cancelOperate: '用户取消操作!',
  zhong: '中',
  ying: '英',
  jian: '柬',
  submit: '提交',
  required: '请输入必填项!',
  edit: '编辑',
  batchDelete: '批量删除',
  delete: '删除',
  add: '添加',
  top: '置顶',
  selection_required: "请至少选择一项",
  enter_num_between: "请输入{arg0}到{arg1}之间的数字",
  return: '返回',
  upload_file: "上传文件",
  upload_img: "上传图片",
  deleteVideo: "删除视频",
  upload_type_img: "支持 {type} 类型的图片，每张不超过{size}",
  invalid_file_type: "文件格式不正确",
  upload_fail: "上传失败",
  file_format_fail: '文件格式有误',
  noData: '暂无数据',
  invalid_phone: '请输入合法的手机号',
  loading_map: '地图加载中',
  map_load_failed: "地图加载失败,请刷新重试",
  preview: "预览",
  size: "大小",
  copy: '复制',
  copySuccess: '复制成功！',
  semicolon: '：',
  tipsSwitch: '如有多张图片,点击图片后可以进行切换！',
  lastWeek: '最近一周',
  lastMonth: '最近一个月',
  lastTreeMonth: '最近三个月',
  lastTwoMonth: '最近两个月',
  today: '今天',
  nextThreeDays: '未来三天',
  nextWeek: '未来一周',
  nextMonth: '未来一个月',
  nextStep: '下一步',
  network_error: "网络异常",
  simplified: '简体中文',
  numberLetterRequired: '只能输入英文、数字组合'
}
